import React from "react";
import { CommandBlock } from "../common/Commands2";

import StageHeader from "./StageHeader";

export default function InvoiceExportStage({
  system,
  period,
  stage,
  stageIndex,
}) {
  const extraFields = [
    {
      label: "Invoice No",
      render(command) {
        return command.state.invoiceNumber || "-";
      },
    },
  ];

  return (
    <>
      <StageHeader stageIndex={stageIndex} stage={stage} />
      <CommandBlock
        endpoint={`/bill/${system}/${period}/${stage.stage}/invoice-email-commands`}
        enabled
        schedule
        summarize
        extraFields={extraFields}
      />
    </>
  );
}
